import { render, staticRenderFns } from "./userGrade.vue?vue&type=template&id=5cfc8d5e&scoped=true&"
import script from "./userGrade.vue?vue&type=script&lang=js&"
export * from "./userGrade.vue?vue&type=script&lang=js&"
import style0 from "./userGrade.vue?vue&type=style&index=0&id=5cfc8d5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc8d5e",
  null
  
)

export default component.exports